<div class="vh_center mt-4">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
      <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
    </div>
  </div>
</div>
<section class=" container">
  <h2 class="text-center header-title page_top_space"> <b>PCB Pricing</b> </h2>

  <div class="mt-4" style="display: flex;justify-content: center;">
    <div class="sub-details">
      <div style="margin-right: 80px;">Quote#: <b>{{commonService.commonMainObj.wmqId}}</b></div>
      <div>Part# / Revision: <b>{{commonService.commonMainObj.uploadedFilesData.partNumber}}</b> / <b>{{commonService.commonMainObj.uploadedFilesData.partRevision}}</b></div>
    </div>
  </div>
  <!-- OFP-3120 -->
  @if(bomUploadSec){
    <div class="text-center txt-align mt-3">
      <div class="text-center bdr-sec">
        <div class="p-1"> <img class=" " src="assets/img/Extracted_icon.png" width="25" height="25" /> Extracted From Uploaded Data File</div>
        <div class="p-1"> <img class=" " src="assets/img/Default_icon.png" width="25" height="25" /> Default Value</div>
        <div class="p-1"> <img class=" " src="assets/img/Updated_icon.png" width="25" height="25" /> User Updated Value</div>
      </div>
    </div>
  }
  @if (commonService.commonMainObj.pcbType == 'Product 1' || commonService.commonMainObj.pcbType == 'Product 2') {
    <div class="mt-5 mb-4 plr-15" >
      <p style="color: #2768D0; font-weight: bold;font-size: 1.2rem;">PCB specifications you've provided align with our standard product specifications, making you eligible for our best price.</p>
      <p>Please make sure that your design complies with the following additional specifications, failing to do so may result in changes to the final quote after placing an order.</p>
      <ul style="font-style: italic;font-size: 14px;">
        <li>Only Rigid boards in simple board shapes built to IPC-6012 Class 2 Spec</li>
        <li>No IPC coupons, impedance coupons, or microsection coupons</li>
        <li>No Milspec</li>
        <li>Assembly Class Specs : IPC-A-610-Class2</li>
        <li>Up to 10 Notches and/or cutouts and/or slots allowed. Minimum slot width 40 mils. Minimum radius 20 mils.</li>
        <li><b>These PCB fabrication features are not allowed</b>: Counter Bore, Counter Sink, multiple images, Arrays, Finger tabs on PCB edge.</li>
        <li>Smallest Passive component size 0201</li>
        <li>Mimium BGA pitch 0.5mm; Minimum other components pitch 0.4mm</li>
        <li>Maximum number of through hole components : 20 per board</li>
        <li>SMT component pad Size: Minimum 8 mils x 8 mils or 8-mil diameter</li>
        <li><b>These Assembly features are not allowed</b>: Wire-bonding, conformal coating, underfills, staking, POP assembly, wire/cable assembly. Rework like cutting traces, wire jumpers. Assembly of PEM nuts, turrets terminals, rivets, and press-fit connectors.</li>
      </ul>
    </div>
  }
  @if (commonService.commonMainObj.pcbType == 'Web PCB') {
    <div class="mt-5 mb-4 plr-15" >
      <!-- <p style="font-weight: bold;">The PCB specifications you've provided is eligible for online pricing but does not fit the specifications for our best price. </p> -->
      <p style="font-weight: bold; margin-bottom: 0px;">The PCB specifications you've provided meet the criteria for online pricing but do not qualify for our best price.</p>
      <p>Here are the <span class="ofp-link" style="font-style: italic;color: var(--bs-link-color)!important;padding-left: 0;" (click)="openListOfPcbSpecification(listOfPcbSpecification)">List of PCB Specifications</span> that do not meet the requirements for our best price.</p>
      <p>NOTE: To get the best price, you can click on the 'Back' button and change the PCB specifications to align with our standard product defined in <a href="{{apiService.sierraStandardProductLink}}" target="_blank" style="font-weight: bold;">Sierra Standard Product</a>.</p>
    </div>
  }
  <div class="page-heading mt-3 plr-15" >Choose Available Turn Time & Quantity: Fabrication</div>
  <div class="mb-3 plr-15 yellow-txt f-14">PER UNIT PRICES FOR PCBs</div>
  <div class="plr-15 mb-3">
    <table class="table table-bordered fab-matrix-table"  id="fab-matrix-table" style="text-align: center;">
      <thead>
        <tr>
          <th>Fabrication Turn time<hr style="margin: 5px;">Quantity</th>
          @for (mat of commonService.commonMainObj.priceMatrixColData; track mat; let i = $index) {
            <th class="pad-b25 text-center">
              {{ mat.field }}
            </th>
          }
        </tr>
      </thead>
      <tbody>

        @for (element of commonService.commonMainObj.priceMatrixRowData; track element; let i = $index) {
          <tr>
            <td class="mat-qty" style="font-weight: bold;">{{commonService.commonMainObj.priceMatrixRowData[i].turnTimeQuantity}}</td>
            <!-- <td *ngFor="let item of element | keyvalue">
            <div *ngIf = "item.key!= 'turnTimeQuantity'">
              <input class="mr-5"  type="radio" name="panel-main-get-quote-pcb-matrix-turnTimeQuantity" id='panel-main-get-quote-pcb-matrix-turnTimeQuantity' value="{{item.key}}" [attr.data-quantity]="commonService.commonMainObj.priceMatrixRowData[in].turnTimeQuantity" class="mr-5"(click)="checkPrice(item.key,commonService.commonMainObj.priceMatrixRowData[in].turnTimeQuantity,item.value)">
              <label for="panel-main-get-quote-pcb-matrix-turnTimeQuantity0"  >${{item.value}}</label>
            </div>
          </td> -->
          @for (col of commonService.commonMainObj.priceMatrixColData; track col; let j = $index) {
            <td class="mat-d" style="text-align: center;">
              @if (commonService.commonMainObj.priceMatrixRowData[i][col.field].split(',')[1] != 1) {
                <input type="radio" name="panel-main-get-quote-pcb-matrix-turnTimeQuantity" id='panel-main-get-quote-pcb-matrix-turnTimeQuantity' value="{{col.field}}" [attr.data-quantity]="commonService.commonMainObj.priceMatrixRowData[i].turnTimeQuantity" class="mr-5 select-price" (click)="checkPrice(col.field,commonService.commonMainObj.priceMatrixRowData[i].turnTimeQuantity,commonService.commonMainObj.priceMatrixRowData[i][col.field])">
              }
              @if (commonService.commonMainObj.priceMatrixRowData[i][col.field].split(',')[1] != 1) {
                <label class="mat-lable" for="panel-main-get-quote-pcb-matrix-turnTimeQuantity0"  >${{commonService.commonMainObj.priceMatrixRowData[i][col.field].split(',')[0]}}</label>
              }
              @if (commonService.commonMainObj.priceMatrixRowData[i][col.field].split(',')[1] == 1) {
                <div style="font-size: 0.9rem;line-height: 1.2;">
                  <div style="font-size: 0.8rem; padding-bottom: 5px;">Not Applicable for Online Quote</div>
                  <a [hidden]="col.field == '1 Days' || col.field == '1 Day'" style="color: #0d6efd;text-decoration: underline; cursor: pointer;" (click)="navigateToCustomeQuote(col.field,commonService.commonMainObj.priceMatrixRowData[i].turnTimeQuantity,'')">Request for Custom Quote</a>
                </div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
  <div class="mb-3 f-14"><b>TOOLING NRE = $0.00 <span style="color: red;">Free!</span></b></div>
</div>
<div class="row" [hidden]="isHidden">
  <div class="col-8">
    <div class="page-heading plr-15" >Choose Available Turn Time & Quantity: Assembly</div>
    <div class="mb-3 plr-15 yellow-txt f-14">PER UNIT PRICES FOR ASSEMBLY LABOR</div>
    <div class="plr-15 mb-3">
      <table class="table table-bordered"  id="assembly-matrix-table" style="text-align: center;">
        <thead>
          <tr>
            <th>Turn time<hr style="margin: 5px;">Quantity</th>
            @for (mat of commonService.commonMainObj.assemblyMatrixColData; track mat; let i = $index) {
              <th class="pad-b25 text-center"  >{{commonService.commonMainObj.assemblyMatrixColData[i].field}}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (element of commonService.commonMainObj.assemblyMatrixRowData; track element; let i = $index) {
            <tr>
              <td class="mat-qty" style="font-weight: bold;">{{commonService.commonMainObj.assemblyMatrixRowData[i].turnTimeQuantity}}</td>
              @for (col of commonService.commonMainObj.assemblyMatrixColData; track col; let j = $index) {
                <td class="mat-d">
                  <input  type="radio" name="panel-main-get-quote-assembly-matrix-turnTimeQuantity" id='panel-main-get-quote-assembly-matrix-turnTimeQuantity' value="{{col.field}}" [attr.data-quantity]="commonService.commonMainObj.assemblyMatrixRowData[i].turnTimeQuantity"(click)="checkAssemblyPrice(col.field,commonService.commonMainObj.assemblyMatrixRowData[i].turnTimeQuantity,commonService.commonMainObj.assemblyMatrixRowData[i][col.field])">
                  <label class="mat-lable" for="panel-main-get-quote-assembly-matrix-turnTimeQuantity0"  >${{commonService.commonMainObj.assemblyMatrixRowData[i][col.field]}}</label>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="plr-15 fs-14 mb-3" [hidden]="isHidden">
      <p class="fw-b" style="color: red;"><i>Please note with via-in-pad features, total turn time will be minimum 7 days</i></p>
    </div>
    <div class="plr-15 fs-14" >
      <p>Labor charges shown do not include special services such as wire-bonding and conformal coating. These charges also exclude assembly of components that require special fixtures, such as PEM nuts, Turret Terminals and Press-Fit connectors. If any such special services are required they will be quoted separately after your online order is placed.</p>
    </div>
  </div>
  <div class="col-4">
    <div class="fab-info-sec">
      <h3 class="mb-4 text-center" style="font-size: 1.2rem;">CURRENT SELECTIONS</h3>
      <p class="fw-b" style="color: brown;">PCB Fabrication</p>
      <div class="row mb-3">
        <div class="col-7">PART/REV:</div>
        <div class="col-5 text-right">{{commonService.commonMainObj.partNumber}} / {{commonService.commonMainObj.partRevision}}</div>
      </div>
      <div class="row mb-3">
        <div class="col-7">TURNTIME:</div>
        <div class="col-5 text-right">{{commonService.commonMainObj.selectedFabTurntime}}</div>
      </div>
      <div class="row mb-3">
        <div class="col-7">QUANTITY:</div>
        <div class="col-5 text-right">{{commonService.commonMainObj.selectedFabQuantity}}</div>
      </div>
      <div class="row mb-3">
        <div class="col-7">LOT PRICE:</div>
        <div class="col-5 text-right">{{commonService.commonMainObj.lotPrice}}</div>
      </div>
      <div class="row mb-4 fw-b" style="color: brown;">
        <div class="col-7" style="text-align: right;">TOTAL</div>
        <div class="col-5 text-right">{{commonService.commonMainObj.lotPrice}}</div>
      </div>
    </div>
  </div>
</div>

</section>

<section class="container">
  <div style="display: flex;margin-top: 2rem;">
    <div class="plr-15 get-ass-txt">
      <div class="ofp-tooltip" style="font-weight: normal;">
        <label for="get_assembly_quote" style="font-weight: bold !important;" (mouseover)="showToolTip(1)" (mouseout)="hideToolTip(1)">Get Assembly Quote?</label>
        <span class="tooltiptext" id="pcbFab-1"></span>
      </div>
    </div>
    <div class="btn-group2" id="get_assembly_quote">
      <input (click)="switchOfButtons($event, assemblyErrorModal)" type="button" class="btn btn-switch btn-gray " id="assemblyYes" value="Yes"/>
      <input (click)="switchOfButtons($event, '')" type="button" class="btn btn-switch  btn-green active" id="assemblyNo" value="No" />
    </div>
  </div>
</section>

<section class=" container" id="uploadBomSec" style="display: none;">
  <div class="row m-0 mt-3 mt-5 mb-4">
    <div class="col">
      <div class="page-heading">Assembly Information</div>
      <div class="row">
        <div class="col-sm-3 input-lable text-lg-start">BOM File<span class="required-mark">*</span><br><span style="font-style: italic; font-size: 13px;">(Retrieved from uploaded file)</span></div>
        <div class="col-sm-9">
          @if (commonService.commonMainObj.fileUploadedData.uploadedBOM) {
            <div style="position: relative;">
              <div class="row">
                <div class="col-5">
                  @if (commonService.commonMainObj.autoUploadFileName) {
                    <div class="mt-2">{{commonService.commonMainObj.autoUploadFileName}} </div>
                  }
                  @if (!commonService.commonMainObj.autoUploadFileName) {
                    <div class="mt-2">{{commonService.commonMainObj.uploadedFile?.name}} </div>
                  }
                </div>
                <div class="col-7" style="display: inline-flex;">
                  <div><span class="not-bom-text">Not the BOM you wanted?</span></div>
                  <div><button class="btn btn-warning fs14 me-2" (click)="uploadOtherBom()" title="{{commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name}}"><b>Upload a Different BOM</b></button><br/><span style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
                  <div class="ion-text-left fs15 mt5 pl5">
                    <a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" download style="position: relative;left: -20px;">Download custom BOM format</a>
                  </div>
                </div>
              </div>
            </div>
            <!-- <input type="file" class="form-control customize-input file-input uploadBomInput" value="null" id="assembly_bom_file_upload" name="fileupload" (change)="fileBrowseHandler($event)"/>
            <label for="assembly_bom_file_upload" style="position: absolute;top: 30px;">
              <button class="btn btn-warning fs14 me-2"> Upload another BOM</button>
            </label> -->
            <input type="file" id="fileInputOther" #fileInputOther style="display: none" accept=".xls,.xlsx"
              (change)="fileBrowseHandler($event)"/>
            </div>
          }
          <!-- <div class="mt-2" *ngIf="!commonService.commonMainObj.fileUploadedData.uploadedBOM">
          <input type="file" class="form-control customize-input file-input" value="null" id="assembly_bom_file_upload" name="fileupload" (change)="fileBrowseHandler($event)"/>
        </div> -->
        @if (!commonService.commonMainObj.fileUploadedData.uploadedBOM) {
          <div class="mt-2 mb-1 file-input-container form-control customize-input file-input" >
            <div class="styled-input" style="display: flex;cursor:pointer;" (click)="fileInput.click()">
              <div class="choose-file" >Choose file</div>
              <div class="upload-name" title="{{  curentAssemblyFileUploadedName }}">{{  curentAssemblyFileUploadedName || 'No file chosen' }}
              </div>
            </div>
            <input type="file" #fileInput style="display: none" accept=".xls,.xlsx" (change)="fileBrowseHandler($event)"/>
          </div>
        }
        @if (!commonService.commonMainObj.fileUploadedData.uploadedBOM) {
          <span style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
        }
        <div class="ps-4">
          @if (!commonService.commonMainObj.fileUploadedData.uploadedBOM) {
            <a  href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" style="position:relative;left:-20px;">Download custom BOM format</a>
          }
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-3 input-lable text-lg-start">
        <div class="ofp-tooltip">
          <label for="assemblySidesNumber" (mouseover)="showToolTip(2)" (mouseout)="hideToolTip(2)">Number of sides to be assembled</label>
          <span class="tooltiptext" id="pcbFab-2"></span>
        </div>
      </div>
      <div class="col-9 btn-group2" id="assemblySidesNumber">
        <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch" id="numberOfSidesOne" value="One side"/>
        <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch" id="numberOfSidesTwo" value="Two sides"/>
        <div  class="ofp-tooltip">
          <img class=" " src="assets/img/{{numOfSidesImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(numOfSidesImg)" (mouseout)="hideImageToolTip(numOfSidesImg)" style="margin-left: 10px;"/> 
          <span class="labelimagetooltip tooltiptext lableImageLabel-{{numOfSidesImg}}"></span>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-3 input-lable text-lg-start">
        <div class="ofp-tooltip">
          <label for="lead_free_processing" (mouseover)="showToolTip(3)" (mouseout)="hideToolTip(3)">Lead-free processing</label>
          <span class="tooltiptext" id="pcbFab-3"></span>
        </div>
      </div>
      <div class="col-9 btn-group2" id="lead_free_processing">
        <div class="ofp-tooltip">
          <div (mouseover)="showLeadFreeToolTip(1)" (mouseout)="hideLeadFreeToolTip(1)">
            <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch" id="leadFreeYes" value="Yes" />
          </div>
          <span class="tooltiptext" id="leadFreeProcess-1"></span>
        </div>
        <div class="ofp-tooltip">
          <div (mouseover)="showLeadFreeToolTip(2)" (mouseout)="hideLeadFreeToolTip(2)">
          <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch" id="LeadFreeNo" value="No"  disabled/></div>
          <span class="tooltiptext" id="leadFreeProcess-2"></span>
        </div>
        <div  class="ofp-tooltip">
          <img class=" " src="assets/img/{{leadFreeImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(leadFreeImg)" (mouseout)="hideImageToolTip(leadFreeImg)" style="margin-left: 10px;"/> 
          <span class="labelimagetooltip tooltiptext lableImageLabel-{{leadFreeImg}}"></span>
        </div>
        <button id="leadFreeAdditionalMessage" hidden (click)="openLeadFreeAdditionalMessage(additionalMessageModal)"></button>
        <input type="hidden" id="contentModalName"  [(ngModel)]="modalName"/>
      </div>
    </div>
    @if (commonService.commonMainObj.pcbType == 'Web PCB') {
      <div class="row mt-3" >
        <div class="col-sm-3 input-lable text-lg-start">PCB has <a style="color:#0787bc;cursor: pointer;text-decoration: underline;" href="{{apiService.Via_In_Pad_URL}}" target="_blank">Via-in-pad</a> features?</div>
        <div class="col-sm-9" id="viaInPads">
          <div class="ofp-tooltip">
            <input type="button" class="btn btn-switch" id="viaInPadsYes" value="Yes" (click)="switchOfButtons($event,'')"/>
            <!-- <span class="tooltiptext" id="viaInPadInfo">You have chosen a PCB fabrication time of {{selectedFabTurntimeVal}} days.
              In order to <span style="color: green;">fill your via-in-pads with non-conductive fill,</span> we will need PCB fabrication cycle of 5 days or more.
              Kindly choose a turn time for 5 days or more in the PCB price matrix above.
            </span> -->
          </div>
          <input type="button" class="btn btn-switch" id="viaInPadsNo" value="No" (click)="switchOfButtons($event,'')"/>
          <div  class="ofp-tooltip">
            <img class=" " src="assets/img/{{commonService.commonMainObj.viaInPadCommonImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(commonService.commonMainObj.viaInPadCommonImg)" (mouseout)="hideImageToolTip(commonService.commonMainObj.viaInPadCommonImg)" style="margin-left: 10px;"/> 
            <span class="labelimagetooltip tooltiptext lableImageLabel-{{commonService.commonMainObj.viaInPadCommonImg}}"></span>
          </div>
        </div>
      </div>
    }
    <!-- <div class="row mt-3 ">
    <div class="col-sm-4 input-lable text-right">
      <label for="needItarComplianceDiv">Need ITAR Compliance?<span style="color:red;padding-left: 3px;">*</span></label>
    </div>
    <div class="col-sm-8" id="needItarComplianceDiv">
      <ul class="list-group" id="itarRadioButtonGroup">
        <li class="list-group-item border-0 dib" style="margin-top: 0px">
          <input type="radio" class="form-check-input me-1" value="1" id="itarYes" name="itar" (change)="changeItarToSwitchButtons($event)" />
          <label class="form-check-label" for="itarYes" >Yes</label>
        </li>
        <li class="list-group-item border-0 dib">
          <input type="radio" class="form-check-input me-1" value="2" id="itarNo" name="itar" (change)="changeItarToSwitchButtons($event)"/>
          <label class="form-check-label" for="itarNo">No</label>
        </li>
      </ul>
      <div  class="btn-group8" id="itarSwitchButtonGroup" >
        <input type="button" class="btn btn-switch btn-green active" id="itarSitchYes" value="Yes" (click)="switchOfButtons($event)"/>
        <input type="button" class="btn btn-switch btn-gray " id="itarSitchNo" value="No" (click)="switchOfButtons($event)"/>
      </div>
    </div>
  </div> -->
  <div class="row mt-3">
    <div class="col-sm-3 input-lable text-lg-start">
      <div class="ofp-tooltip">
        <label for="assembly_quantity" (mouseover)="showToolTip(4)" (mouseout)="hideToolTip(4)">Quantity of assembled boards<span class="required-mark">*</span></label>
        <span class="tooltiptext" id="pcbFab-4"></span>
      </div>
    </div>
    <div class="col-sm-3">
      <input type="text" id="assembly_quantity" [(ngModel)]="commonService.commonMainObj.qtyAssemblies" class="form-control customize-input" disabled readOnly="true" style="width: 58%;"/>
      <!-- <select id="assembly_quantity" [(ngModel)]="commonService.commonMainObj.qtyAssemblies" class="form-control form-select customize-input">
      <option value="{{brdQty}}" *ngFor="let brdQty of qtyIndvBoardsArray; let k = index">{{brdQty}}</option>
    </select> -->
  </div>
</div>
</div>
</div>
</section>
<section class="container mb-4 mt-4">
  <div class="text-center">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="backToBoardDetails()"><b>Back</b></button>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="commonService.goBack()"><b>Cancel</b></button>
    <button id="quote-proceed-btn" type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="bomProceed(autoMapping)"><b>Proceed</b></button>
  </div>
</section>

<ng-template #autoMapping let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">BOM Column Mapping</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  @if (showNumberOfSheets) {
    <div class="modal-body pt-0">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center mb-3"><b><u>Map the column headings for your BOM</u></b></div>
          <div class="text-center fs14 text-danger"> <b>Note: </b> Please select the column name for the mandatory columns that are not auto-mapped. If any of the mandatory columns are not present in the BOM, click on "Cancel" button and upload a new BOM that has all the mandatory columns.</div>
        </div>
      </div>
      <!-- Changes done based on OFP-652 -->
      <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
        @for (cma of mainRowArrayObj['labelsArray']; track cma; let idx = $index) {
          <div class="row justify-content-md-center" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
            @if ((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
              <div class="row justify-content-md-center" >
                <div class="col-sm-3">
                  <div>
                    @if (cma.labelType != 'new') {
                      <label>{{cma.labelName}}@if ((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
                        <span class="text-danger">*</span>
                      }</label>
                    }
                  </div>
                </div>
                <div class="col-sm-4">
                  <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                  <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" [ngClass]="cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number' ? 'requiredField' : 'notRequireField'" placeholder="Select" [(ngModel)]="cma.selectedName1" (change)="checkIfAllOptionsPresent()">
                    <option value="">Select</option>
                    @for (crow of mainRowArrayObj['bomOneMapArrayData']; track crow) {
                      <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj">
                        {{crow.labelValue}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
        @for (cma of mainRowArrayObj['labelsArray']; track cma; let idx = $index) {
          <div class="row justify-content-md-center" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
            @if (!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
              <div class="row justify-content-md-center" >
                <div class="col-sm-3">
                  <div>
                    @if (cma.labelType != 'new') {
                      <label>{{cma.labelName}}@if ((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
                        <span class="text-danger">*</span>
                      }</label>
                    }
                  </div>
                </div>
                <div class="col-sm-4">
                  <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                  <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" placeholder="Select" [(ngModel)]="cma.selectedName1">
                    <option value="">Select</option>
                    @for (crow of mainRowArrayObj['bomOneMapArrayData']; track crow) {
                      <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj">
                        {{crow.labelValue}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (!showNumberOfSheets) {
    <div class="modal-body">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center clr_green mb-5"><b>Your excel has multiple worksheets. Please specify worksheet that has BOM info.</b></div>
          <div class="row justify-content-md-center">
            <div class="col-sm-3">
              <label>Select Sheet: </label>
            </div>
            <div class="col-sm-4">
              <select class="form-control form-select mb-3" placeholder="Select" [(ngModel)]="selectedSheetNum">
                <option value="">Select</option>
                @for (sheet of sheetsArray; track sheet) {
                  <option value="{{sheet.index}}">
                    {{sheet.name}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!showNumberOfSheets) {
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-custom btn_blue_custom btn-warning px-xxl-5" (click)="proceedSheet()"><b>Proceed</b></button>
    </div>
  }
  @if (showNumberOfSheets) {
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 mr-25 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
      <button type="button" class="btn btn-custom btn_blue_custom btn-warning px-xxl-5" id="automap-modal-proceed-btn" (click)="proceedAutoMapData()" ><b>Proceed</b></button>
      <!-- (click)="modal.close('Save click')" [disabled]="disableAutomapProceed == true" OFP-613 -->
    </div>
  }
</ng-template>
<ng-template #via_in_pad let-modal class="address-book-modal">
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">List of Specifications</h4> -->
    <div class="row col text-right">
      <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="modal-crose">×</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <iframe id="via_in_pad_frame" src="https://www.protoexpress.com/customer-portal/via-in-pad-features.jsp&embedded=true"  ></iframe>
  </div>
</ng-template>
<ng-template #assemblyErrorModal let-modal>
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">Assembly File Errors</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <!-- OFP-3156 changed the below text -->
    <div class="text-center text-danger">Please resolve errors to get assembly quote.</div>
    <!-- <button type="button" (click)="reValidate();"></button> -->
    <div>
      <!-- <div class="p-2 bg-warnings fw-b">Errors:</div> -->
      <div class="brd_warning">
        <!-- <ul class="list-type-number">
        <li *ngFor="let assmblyErr of commonService.commonMainObj.uploadedFilesData?.fileAsmblyErrors; index as idx" >
          <div class="row">
            <div class="col-7"><span>{{assmblyErr.error}}</span>
            <span class="ass-err-tooltip">
              <span class="fa fa-info-circle" style="padding-left: 5px;" (mouseover)="showAssToolTip(assmblyErr.description,idx+1)" (mouseout)="hideAssToolTip(assmblyErr.description,idx+1)"></span>
              <span class="tooltiptext" id="infoIcon-{{idx+1}}"></span>
            </span>
          </div>
          <div class="col-5">
            <label for="{{assmblyErr.errorCode}}" class="missing-file-lable">
              <input type="file" class="missing-file-input" id="{{assmblyErr.errorCode}}" (change)="missingFilesHandel($event, ''+assmblyErr.errorCode)">
              <i class="fa fa-cloud-upload"></i> Upload
            </label>
            <div>
              <span id="{{assmblyErr.errorCode}}_name" class="file-color"></span>
              <span style="display: none;" class="delete-file fa-del fa fa-solid fa-trash" id="{{assmblyErr.errorCode}}_delete" (click)="deleteFile(''+assmblyErr.errorCode)"></span>
            </div>
          </div>
        </div>

        <span id="{{assmblyErr.errorCode}}_error" class="error-message"></span>
      </li>
    </ul> -->
    <div class="table-row">
      <table class="table warning-table mt-4" style="width: 100%; word-break: break-word;">
        <thead>
          <tr>
            <th style="width: 30%;text-align:center; background-color:#fcb816;">Error</th>
            <th style="width: 30%;text-align:center; background-color:#fcb816;">Additional Information</th>
            <!-- <th style="width: 40%;text-align:center; background-color:#fcb816;"> &nbsp; </th> -->
          </tr>
        </thead>
        <tbody>
          @for (assmblyErr of commonService.commonMainObj.uploadedFilesData?.fileAsmblyErrors; track assmblyErr; let idx = $index) {
            <tr>
              <td style="width: 50%;vertical-align: top;">
                <div style="font-size: 1rem;color:#e37403;font-weight: 500;">{{assmblyErr.error}}</div>
                <div class="text-right">
                  <label for="{{assmblyErr.errorCode}}" class="missing-file-lable">
                    <input type="file" class="missing-file-input" id="{{assmblyErr.errorCode}}" (change)="missingFilesHandel($event, ''+assmblyErr.errorCode)">
                    <i class="fa fa-cloud-upload"></i> Upload
                  </label>
                </div>
                <div>
                  <span id="{{assmblyErr.errorCode}}_name" class="file-color"></span>
                  <span style="display: none;" class="delete-file fa-del fa fa-solid fa-trash" id="{{assmblyErr.errorCode}}_delete" (click)="deleteFile(''+assmblyErr.errorCode)"></span>
                </div>
                <span id="{{assmblyErr.errorCode}}_error" class="error-message"></span>
              </td>
              <td style="width: 50%; color: #59544f;">{{assmblyErr.description}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
<div class="modal-footer text-center" style="display: block;">
  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
  <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3 " id="assembly_error_proceed" [disabled]="disableAssemblyErrorProceed == true" (click)="reValidate()"><b>Proceed</b></button>
</div>
</ng-template>
<!--For listOfPcbSpecification -->
<ng-template #listOfPcbSpecification let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">List of PCB Specifications</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
      <ul>
        @for (item of commonService.commonMainObj.webPCBQuoteParameters | keyvalue; track item) {
          <li style="list-style-type: auto;padding-bottom: 2px">{{item.value}}</li>
        }
      </ul>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 " (click)="modal.close('cancel click')"><b>Ok</b></button>
  </div>
</ng-template>
<ng-template #additionalMessageModal let-modal class="address-book-modal">
  <div class="modal-header">
    <div class="row col text-right">
      <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="modal-crose">×</span>
      </button>
    </div>
  </div>
  <div class="modal-body text-center">
    @if(commonService.commonMainObj.additionalTextHasl){
      <div id="additionalTextHasl">To proceed with online quote, {{commonService.commonMainObj.leadfreeHasl}} But value extracted is <b>{{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance}}</b><i class="fa fa-info-circle info-icon file-info-icon" title ="Extracted File Name: {{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance_extracted_from}}"></i>. We will proceed with 'Lead-free Processing' as 'No'. </div>
    }
    @if(commonService.commonMainObj.additionalTextEnig){
      <div id="additionalTextEnig">To proceed with online quote, {{commonService.commonMainObj.leadedEnig}} But value extracted is <b>{{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance}}</b><i class="fa fa-info-circle info-icon file-info-icon" title ="Extracted File Name: {{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance_extracted_from}}"></i>. We will proceed with 'Lead-free Processing' as 'Yes'. </div>
    }
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom" (click)="navigateToCustomeQuote(commonService.commonMainObj.selectedFabTurntime,commonService.commonMainObj.selectedFabQuantity,true)" ><b>Use Extracted Value for Custom Quote</b></button>
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom" (click)="continueWithOnlineQuote()" ><b>Accept and Proceed with Online Quote</b></button>
  </div>
</ng-template>
<app-footer></app-footer>